import { Component } from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-cookiepolicy-setting',
  templateUrl: './cookiepolicy-setting.component.html',
  styleUrl: './cookiepolicy-setting.component.css'
})
export class CookiepolicySettingComponent {

  pdpaUrl: string = '';


  constructor(
    private homeService : HomeService,
    private configService: ConfigService
  ){
    let result =  []

    if(this.configService.siteName == 'MOJ'){
      this.pdpaUrl = 'assets/pdpa_moj.pdf';
      return;
    }

    this.homeService.getParameter('PDPAUrl').subscribe({
      next:(VALUE) => {
        result = VALUE
      },
      complete:() => {
        if (result.length == 1) {
          this.pdpaUrl = result[0].VALUE;
        } 
      },
      error:() => {
        this.pdpaUrl =  ''
      }
    });
  }
}
